import { AnimatePresence, motion } from "motion/react";
import { cn } from "@/core/helpers/cn";
import getDeathGradient from "@/domains/deathScreen/helpers/getDeathGradient";

type Props = {
  className?: string;
  isPulse: boolean;
};

export default function DeathScreenRedGradient({ className, isPulse }: Props) {
  return (
    <AnimatePresence>
      {isPulse ? (
        <motion.div
          initial={{
            backgroundImage: getDeathGradient(60),
            opacity: 0.7,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          exit={{ opacity: 0.7 }}
          className={cn("fixed top-0 left-0 right-0 bottom-0", className)}
          key="alive"
        />
      ) : (
        <motion.div
          initial={{
            backgroundImage: getDeathGradient(100),
            background: "rgba(18, 18, 18, 0.96)",
            opacity: 0.2,
          }}
          animate={{
            opacity: 1,
            background: "rgba(18, 18, 18, 0.96)",
            boxShadow: "rgba(215, 52, 52, 0.4) 0px 0px 250px 0px inset",
          }}
          transition={{
            duration: 2,
          }}
          exit={{ opacity: 0.7 }}
          className={cn("fixed top-0 left-0 right-0 bottom-0", className)}
          key="death"
        />
      )}
    </AnimatePresence>
  );
}
